module.exports = __webpack_public_path__ + "static/media/react-icon.b9b3b6ca.svg";